export default function Spinner({ size = 24, className = '' }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-block animate-spin rounded-full border-2 border-white/20 border-t-white ${className}`}
      style={{ width: size, height: size }}
    >
      <span className="sr-only">Yuklanmoqda…</span>
    </span>
  )
}
